import { createStore } from '../../state'

import type { StateStorage } from 'zustand/middleware'

export interface MigrateV2Store {
  hasMigrated: boolean
  setHasMigrated: (hasMigrated: boolean) => void
}

export const createMigrateToV2Store = (storage: StateStorage) =>
  createStore<MigrateV2Store>(
    storage,
    (set) => ({
      hasMigrated: false,
      setHasMigrated: (hasMigrated: boolean) => {
        set({ hasMigrated })
      },
    }),
    {
      persist: {
        name: 'migrateV2',
        version: 0,
      },
    }
  )
